<template>
  <div>
    <!-- 下拉选择器触发区域 -->
    <div
      class="selector-input"
      :class="customClass"
      @click="showActionSheet = true"
    >
      <van-field v-model="displayValue" readonly :placeholder="placeholder" />
      <img src="@/assets/images/down.png" alt="下拉" />
    </div>

    <!-- 动作面板 -->
    <van-action-sheet
      v-model="showActionSheet"
      :actions="options"
      :overlay="options.length > 0"
      :cancel-text="cancelText"
      @cancel="handleCancel"
      @select="handleSelect"
      @open="handleOpen"
    />
  </div>
</template>

<script>
export default {
  name: "SelectorDropdown",
  props: {
    // 选项列表，格式: [{name: '显示文本', value: '值'}, ...]
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 当前选中的值
    value: {
      type: [String, Number],
      default: "",
    },
    // 占位文本
    placeholder: {
      type: String,
      default: "请选择",
    },
    // 取消按钮文本
    cancelText: {
      type: String,
      default: "取消",
    },
    // 自定义类名
    customClass: {
      type: String,
      default: "",
    },
    // 是否在取消时清空选择
    clearOnCancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showActionSheet: false,
      selectedValue: this.value,
    };
  },
  computed: {
    displayValue() {
      const selectedOption = this.options.find(
        (item) => item.value === this.selectedValue
      );
      return selectedOption ? selectedOption.name : "";
    },
  },
  watch: {
    value(newVal) {
      this.selectedValue = newVal;
    },
  },
  methods: {
    handleSelect(action) {
      this.selectedValue = action.value;
      this.$emit("input", action.value);
      this.$emit("change", action.value);
      this.showActionSheet = false;
    },
    handleOpen() {
      if (this.options.length === 0) {
        this.showActionSheet = false;
        this.$toast("该账户暗户ID为空");
      }
    },
    handleCancel() {
      if (this.clearOnCancel) {
        this.selectedValue = "";
        this.$emit("input", "");
        this.$emit("change", "");
      }
      this.$emit("cancel");
      this.showActionSheet = false;
    },
  },
};
</script>

<style scoped lang="scss">
.selector-input {
  width: 100%;
  height: 22px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #ded9d9;
  font-family: Inter;
  font-weight: 400;
  color: #000000;
  align-items: center;
  display: flex;
  align-items: center;

  .van-cell {
    padding: 0;
    padding-left: 6px;
    flex: 1;
    align-items: center;
    height: 100%;
    font-size: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border: none;
  }

  img {
    margin-right: 5px;
    width: 12px;
    height: 13px;
    object-fit: contain;
  }
}
</style>
